import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { contentClick, loadMoreInteraction } from '../../../../../helpers/datalayer-utils';
import { BQLink } from '../../../../atoms/bqlink';
import { ArrowRightIcon, FinanceIcon, FourStarIcon } from '../../../../atoms/material-icons';
import StoryCardHorizontalWithImageAllContent from '../../../../molecules/story-card/story-card-horizontal-with-image-all-content';
import EmptyState from '../empty-state';
import './more-from-markets.m.css';

const MoreFromMarkets = ({ newsData }) => {
  const newsSectionSingleStory = newsData?.slice(0, 1);
  const newsSectionThreeStory = newsData?.slice(1, 7);
  const [initialLoading, setInitialLoading] = useState(true);
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return (
    <div styleName="more-markets-container">
      <div styleName="header-title-container">
        <FinanceIcon size={'26px'} color={'#d01e51'} />
        <h2 styleName="list-header-title">MORE MARKET NEWS</h2>
      </div>
      {newsData && newsData?.length > 0 ? (
        <>
          <div styleName="news-section-single-story">
            <StoryCardHorizontalWithImageAllContent story={newsSectionSingleStory[0]} />
          </div>
          <div styleName="news-section-single-story-mobile">
            <BQLink href={new URL(newsSectionSingleStory[0]?.link)?.pathname}>
              <div styleName="image-container">
                <img src={newsSectionSingleStory[0]?.thumb_image + '?downsize=400:264'} alt="thumb image" styleName="thumb-image" />
                <h2 styleName="image-overlay">{newsSectionSingleStory[0]?.title}
                  {newsSectionSingleStory[0]?.category === 'Research Reports' && (
                    <span className="exclusive-icon">
                      <FourStarIcon color="#CE9445" size="14px" />
                    </span>
                  )}
                </h2>
              </div>
            </BQLink>
          </div>
          <div styleName="three-story-news">
            {newsSectionThreeStory?.map((news, index) => (
              <div
                onClick={() => contentClick(userData, news?.story || news, pageType)}
                key={index}
              >
                <BQLink href={new URL(news?.link)?.pathname} key={index}>
                  <h3 styleName="news-content" className="truncate-overflow">
                    {news?.title}
                    {news?.tags?.includes('Research Reports') && (
                      <span className="exclusive-icon">
                        <FourStarIcon color="#CE9445" size="14px" />
                      </span>
                    )}
                  </h3>
                </BQLink>
              </div>
            ))}
          </div>
          <div
            styleName="btn-container"
            onClick={() =>
              loadMoreInteraction(
                'Read More',
                userData,
                pageType,
                'MORE MARKET NEWS',
              )
            }
          >
            <BQLink
              styleName="read-more-btn"
              href={'/all-market-news'}
            >
              Read More <ArrowRightIcon color={'#d01e51'} styleName="tab-icon" />
            </BQLink>
          </div>
        </>
      ) : (
        <div styleName="no-data-container-ext">
          <div styleName="no-data-container-int">
            <EmptyState />
          </div>
        </div>
      )}
    </div>
  );
};

MoreFromMarkets.propTypes = {
  newsData: PropTypes.array
};

export default MoreFromMarkets;
